module.exports = __webpack_public_path__ + "static/media/amp_logo.96becba2.svg";